import { useQuery } from "@tanstack/react-query";
import { ClimbType } from "griptonite-api-client";
import { useMemo } from "react";

import api from "../core/api";
import { getGradeSystemsForClimbType } from "../utils/grades";
import { useCurrentVenueQuery, useCurrentClimbType } from "./venues";

export const useGradesQuery = () => {
  return useQuery({
    queryKey: ["grades"],
    queryFn: api.routes.getGrades,
    staleTime: 1000 * 60 * 60 * 24,
  });
};

const emptyArray: never[] = [];

export const useGradeSystemChoices = (climbType?: ClimbType) => {
  const { data: venue } = useCurrentVenueQuery();
  const defaultClimbType = useCurrentClimbType();
  climbType = climbType || defaultClimbType;

  const gradeSystemChoices = useMemo(() => {
    if (!climbType) {
      return emptyArray;
    }
    const extraSystems = venue
      ? climbType === "BOULDER"
        ? venue?.boulderGradeSystems
        : venue?.sportGradeSystems
      : emptyArray;

    return [...new Set(getGradeSystemsForClimbType(climbType).concat(extraSystems))];
  }, [venue, climbType]);

  return gradeSystemChoices;
};

export const useVenueGradeSystem = (climbType?: ClimbType) => {
  const { data: venue } = useCurrentVenueQuery();
  const defaultClimbType = useCurrentClimbType();
  climbType = climbType || defaultClimbType;

  return climbType === "SPORT"
    ? venue?.sportGradeSystem || "FRENCH"
    : venue?.boulderGradeSystem || "FONT";
};
